import AuthenticationStore from "../stores/AuthenticationStore";
import React from "react";
import { Redirect, Route } from "react-router-dom";

class PrivateRoute extends React.Component {
  state = {
    loggedIn: AuthenticationStore.loggedIn()
  };

  componentDidMount() {
    AuthenticationStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthenticationStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      loggedIn: AuthenticationStore.loggedIn()
    });
  };

  render() {
    const { component: Component, ...rest } = this.props;
    const { loggedIn } = this.state;

    return (
      <Route
        {...rest}
        render={props =>
          loggedIn ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: `/login${
                  props.location.search ? props.location.search : ""
                }`,
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }
}

export default PrivateRoute;
